export default __webpack_public_path__ + "static/media/check-white.f31a92e1.svg";